import { BehaviorSubject } from 'common/barrels/rx';

import { LooklessControl } from 'runtime/controls/looklesscontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { GenericEvent } from 'runtime/events/genericevent';
import { registerBinding } from 'runtime/bindingengine';

export class EventSender extends LooklessControl {
    private eventName: string;
    private eventPayload: BehaviorSubject<string>;

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.eventName = this.config['content.EventName'];

        this.eventPayload = new BehaviorSubject<string>(this.config['content.Payload']);

        this.subscriptions = this.processBindings(this.config);
    }

    'content.Payload'(value: string) {
        this.eventPayload.next(value);
    }

    sendEvent() {
        this.eventAggregator.publish(new GenericEvent(this.eventName, this.eventPayload.getValue() || ''));
    }
}

registerBinding('eventsender', EventSender);